var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEducational = function SvgEducational(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 83 83"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 47262"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 47261"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h83v83H0z",
    "data-name": "Rectangle 26161"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 47260"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m55.227 43.357-13.879 8.328L6.891 31.011l34.457-20.674 34.457 20.674-13.88 8.326 10.433 6.261v26.759h-6.891V49.5l-3.446-2.067v12.522l-20.674 12.4-20.674-12.4V47.316l20.674 12.4L61.924 47.37Z",
    "data-name": "Path 44906"
  }))))));
};
export default SvgEducational;